"use client";

import { createContext, useContext, useState } from "react";
import useApi from "../Hooks/useApi";
import {
  removeLocalData,
  setAuthTokens,
  setUserData,
} from "../Helpers/authHelper";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const { request } = useApi();

  const login = async ({ email, password }) => {
    try {
      const data = await request("POST", "/v1/auth/authenticate", {
        data: { email, password },
      });

      if (data.access_token && data.refresh_token) {
        setAuthTokens(data.access_token, data.refresh_token);

        try {
          const userData = await request("GET", "/v1/user", {
            headers: {
              Authorization: `Bearer ${data.access_token}`,
            },
          });

          setUserData(userData);
          setUser(userData);
          window.location.replace("/modules");
        } catch (e) {
          return { error: "Error Getting User Data" };
        }
      } else {
        return { error: "Authentication failed" };
      }
    } catch (error) {
      // Return the error message from the API response if available
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        throw new Error(error.response.data.message);
      } else if (!error.response) {
        return { error: "Network error" };
      } else {
        return { error: error.message || "Login failed" };
      }
    }
  };

  const logout = () => {
    removeLocalData();
    setUser(null);
    window.location.replace("/login");
  };


  const updateUser = (newUserData) =>{
         setUserData(newUserData);
          setUser(newUserData);
  }


  return (
    <AuthContext.Provider value={{ user, updateUser, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
